import React, { memo } from 'react';
import Spinner from 'core/components/Spinner';
import { ShimmerThinkingIndicator, ThinkingContainer } from '../KaizenChatSession.styles';

// Memoized component to prevent unnecessary re-renders
const ThinkingIndicator = memo(({ text = 'Thinking...' }) => (
  <ThinkingContainer>
    <Spinner size={16} variant="hourglass" />
    <ShimmerThinkingIndicator>{text}</ShimmerThinkingIndicator>
  </ThinkingContainer>
));

ThinkingIndicator.displayName = 'ThinkingIndicator';

export default ThinkingIndicator;
